import { Component, Input } from '@angular/core';
import { WorldMapComponent } from './world-map/world-map.component';
import { MapListComponent } from './map-list/map-list.component';

@Component({
  selector: 'app-search-map',
  templateUrl: './search-map.component.html',
  styleUrls: ['./search-map.component.scss'],
  standalone: true,
  imports: [MapListComponent, WorldMapComponent],
})
export class SearchMapComponent {
  @Input() id!: number;
  @Input() path!: 'playlist' | 'myVideos' | 'videos';
}
